/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DivisionIdError/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DivisionIdError({
  children,
  viewPath = "/App/DivisionIdError"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DivisionIdError.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DivisionIdError.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="DivisionIdError.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
We detected an issue with the iframe code.
</span>
<span
  data-testid="DivisionIdError.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Please, review and fix, or paste it again.
</span>
</div>
</div>
{children}
</React.Fragment>)
}